export default "__VITE_ASSET__9aebb02b__"